export default __webpack_public_path__ + "static/media/tick.c1246568.svg";